/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_SquadsInputs */

const en_mk_mx_squads = /** @type {(inputs: Mk_Mx_SquadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Squads (a lead agent splits the work)`)
};

const id_mk_mx_squads = /** @type {(inputs: Mk_Mx_SquadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Squad (agen pemimpin membagi tugas)`)
};

/**
* | output |
* | --- |
* | "Squads (a lead agent splits the work)" |
*
* @param {Mk_Mx_SquadsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_squads = /** @type {((inputs?: Mk_Mx_SquadsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_SquadsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_squads(inputs)
	return en_mk_mx_squads(inputs)
});